import React from 'react';
import { Link } from 'react-router-dom';
import { mockAgencies } from '../services/dataService';
import { getAgencyImage } from '../utils/imageUtils';

/**
 * Agency List Page Component
 */
const AgencyList = () => {
  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        🌍 Space Agencies
      </h1>
      <div className="grid">
        {mockAgencies.map(agency => (
          <div key={agency.id} className="card">
            <img 
              src={getAgencyImage(agency.id, agency.name)} 
              alt={agency.name}
              style={{ 
                width: '100%', 
                height: '200px', 
                objectFit: 'cover', 
                borderRadius: '8px', 
                marginBottom: '15px' 
              }}
              onError={(e) => {
                e.target.src = `https://via.placeholder.com/400x300/1a1a2e/e94560?text=${encodeURIComponent(agency.name)}`;
              }}
            />
            <h2 style={{ color: 'var(--highlight-color)', marginBottom: '15px' }}>
              {agency.name}
            </h2>
            <p style={{ marginBottom: '10px' }}>
              <strong>Country:</strong> {agency.country}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Founded:</strong> {agency.foundedYear}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Founder:</strong> {agency.founder}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Headquarters:</strong> {agency.headquarters}
            </p>
            <p style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>
              {agency.description}
            </p>
            <div style={{ display: 'flex', gap: '15px', marginBottom: '15px', flexWrap: 'wrap' }}>
              <span style={{ background: 'var(--accent-color)', padding: '5px 10px', borderRadius: '5px', fontSize: '14px' }}>
                {agency.activeRockets} Active Rockets
              </span>
              <span style={{ background: 'var(--accent-color)', padding: '5px 10px', borderRadius: '5px', fontSize: '14px' }}>
                {agency.scientistsCount} Scientists
              </span>
              <span style={{ background: 'var(--accent-color)', padding: '5px 10px', borderRadius: '5px', fontSize: '14px' }}>
                {agency.missionsCount} Missions
              </span>
            </div>
            <Link to={`/agencies/${agency.id}`} className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgencyList;
